// Helpers shared across the citation editor and read-only displays.

// GraphQL exposes the PolicyCitationType enum in SCREAMING_CASE.
export const CITATION_TYPE_ACES = "ACES";
export const CITATION_TYPE_CLIENT = "CLIENT";

// A citation is editable through the UI only when it is a client citation.
// ACES citations are seeded directly into the database and are read-only here.
export const isAcesCitation = (citation) =>
  citation?.citationType === CITATION_TYPE_ACES;

// A citation row is savable only with a label and a safe http/https URL — shared
// by the create and edit editors and matching the server's validation.
export const citationIsValid = (row) =>
  row?.title?.trim() && isSafeCitationUrl(row?.url?.trim());

// Only http/https links are safe to render as clickable deep-links.
export const isSafeCitationUrl = (url) => {
  if (!url) {
    return false;
  }
  try {
    const parsed = new URL(url);
    return parsed.protocol === "http:" || parsed.protocol === "https:";
  } catch {
    return false;
  }
};

// Order ACES citations first, then client, then alphabetically by title — matching
// the server-side ordering (CitationType, then Title).
export const sortCitations = (citations = []) =>
  [...citations].sort((a, b) => {
    if (a?.citationType !== b?.citationType) {
      // ACES before CLIENT
      return a?.citationType === CITATION_TYPE_ACES ? -1 : 1;
    }
    return (a?.title ?? "").localeCompare(b?.title ?? "");
  });
